import React, {createContext, PropsWithChildren, useContext, useEffect, useState} from 'react';
import {getFileTypes} from '../../actions/getFileTypeIDs';
import {FileType} from '../../types';

type FileTypesOptionsContext = {
  fileTypes: FileType[],
  loading: boolean,
}

interface FileTypesOptionsContextProviderProps extends PropsWithChildren<{}> {}

const defaultContext: FileTypesOptionsContext = {
  fileTypes: [],
  loading: false,
};

const FileTypesOptionsContext = createContext<FileTypesOptionsContext>(defaultContext);

export const useFileTypesOptionsContext = () => useContext(FileTypesOptionsContext);

export const FileTypesOptionsContextProvider = ({children}: FileTypesOptionsContextProviderProps) => {
  const [fileTypes, setFileTypes] = useState<FileType[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getFileTypes()
      .then(setFileTypes)
      .catch(console.error)
      .finally(() => setTimeout(() => setLoading(false), 1000));
  }, []);

  return (
    <FileTypesOptionsContext.Provider value={{
      fileTypes,
      loading
    }}>
      {children}
    </FileTypesOptionsContext.Provider>
  );
};